export const FEATURE_NAME = '@zerops/zerops/feature/service-stack-form/modules/nginx-service-stack-form';
